module.exports = __webpack_public_path__ + "img/ring_g_l_1_0@3x.46926ff8.png";